import { z } from 'zod';

const DATE_ONLY_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

const dateOnlyQuerySchema = z
  .string()
  .regex(DATE_ONLY_REGEX, 'fecha must be YYYY-MM-DD')
  .refine((value) => {
    const [year, month, day] = value.split('-').map(Number);
    const parsed = new Date(Date.UTC(year!, month! - 1, day!));
    return (
      year! >= 1 &&
      parsed.getUTCFullYear() === year &&
      parsed.getUTCMonth() === month! - 1 &&
      parsed.getUTCDate() === day
    );
  }, 'fecha must be a valid calendar date');

/** Year selector for the plan-vs-real-year endpoint: YYYY. */
export const PlanVsRealYearQuerySchema = z.object({
  year: z.string().regex(/^\d{4}$/, 'year must be YYYY'),
});

export type PlanVsRealYearQuery = z.infer<typeof PlanVsRealYearQuerySchema>;

/** Day selector for the effective next-billing-date projection. */
export const FacturacionPorDiaQuerySchema = z.object({
  dia: z.coerce.number().int().min(1).max(31),
});

export type FacturacionPorDiaQuery = z.infer<typeof FacturacionPorDiaQuerySchema>;

/** Operational day and optional collector filter for the Ruta de cobros projection. */
export const RutaCobrosQuerySchema = z.object({
  /** Defaults to today's business date in America/Guatemala when omitted. */
  fecha: dateOnlyQuerySchema.optional(),
  idUsuario: z.string().uuid().optional(),
});

export type RutaCobrosQuery = z.infer<typeof RutaCobrosQuerySchema>;
